import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import SmartPoReceive from 'components/Sales/Smart/PoReceive';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { getWarehouseCodeFromCache } from 'utils';

export default function SmartPrepack(): JSX.Element {
  return (
    <ContentLayout 
      titleKey="titles.poreceive" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    >
      {<SmartPoReceive />}
    </ContentLayout>
  );
}
